import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { IGetInstagramPostsData, InstagramPostsPaginationResponse } from '../Models/IInstagramPost';
import { IInstagramPostDetailsPutDto } from '../Models/IInstagramPostDetailsPutDto';
import { IInstagramComment } from '../Models/IInstagramComment';
import { IApiResponseDto, IFilterBody, IPagination, IPolitician, IPostType, ITopic } from '../../../helpers/general.interface';
import { HelperFunctions } from '../../../helpers/HelperFunctions';


@Injectable({
  providedIn: 'root'
})
export class InstagramService {
  constructor(private http: HttpClient) {}

  public getAllPosts(pagination: IPagination, sortBy: string, sortDir: string, searchVal: string, filters: IFilterBody[]): Observable<InstagramPostsPaginationResponse> {
    let params: HttpParams = new HttpParams();
    

    if (pagination) {
      params = HelperFunctions.addPaginationToParams(params, pagination);
    }
    
    if (sortBy)
      params = params.set('sortBy', sortBy);

    
    if (sortDir)
      params = params.set('sortDir', sortDir);
    
    if (searchVal)
      params = params.set('searchVal', searchVal);
    
    return this.http.post<InstagramPostsPaginationResponse>(
      `${environment.instagramUrl}/Instagram/list`,
      filters || [],
      { params: params }
    );
  }


   public updatePostDetails(body: IInstagramPostDetailsPutDto): Observable<IApiResponseDto> {
    let response: Observable<IApiResponseDto> = this.http.put<IApiResponseDto>(`${environment.instagramUrl}/Instagram`, body)
    return response
   }


   public getPostDetails(id: string): Observable<IGetInstagramPostsData> {
    return this.http.get<IGetInstagramPostsData>(`${environment.instagramUrl}/Instagram/${id}`);
  }
  
  public getPostComments(id: string): Observable<IInstagramComment> {
    let response: Observable<IInstagramComment> = this.http.get<IInstagramComment>(`${environment.instagramUrl}/Instagram/${id}/comments`)
    return response
   }

   public getCommentDetails(id: string): Observable<IInstagramComment> {

    let response: Observable<IInstagramComment> = this.http.get<IInstagramComment>(`${environment.instagramUrl}/Comment/${id}`)
    return response
   }


   public getPoliticians(): Observable<IPolitician[]> {
    let response = this.http.get<IPolitician[]>(`${environment.instagramUrl}/Politician/profile-names`);
    return response;
   }
  

   public getAttackedPoliticians(): Observable<IPolitician[]> {
     return this.http.get<IPolitician[]>(`${environment.instagramUrl}/Politician/attacked-politicians`)
       .pipe(
          map(response => response.map(item => ({
            name: item.name,
            id: item.name
        } as IPolitician))));
   }


    public getPoliticianDetails(politicianId: string): Observable<IPolitician> {
       let response = this.http.get<IPolitician>(`${environment.instagramUrl}/Politician/${politicianId}`);
       return response;
    }
     

   public getPostTypes(): Observable<IPostType[]> {

    let response: Observable<IPostType[]> = this.http.get<IPostType[]>(`${environment.instagramUrl}/PostType/list`)
    return response
   }


   public getPostTopics(): Observable<ITopic[]> {

    let response: Observable<ITopic[]> = this.http.get<ITopic[]>(`${environment.instagramUrl}/topic/list`)
    return response
   }
}